import { graphql } from 'GQL/gql';

export const OpportunitySkillFields = graphql(`
  fragment OpportunitySkillFields on OpportunitySkill {
    __typename
    _id
    actualExpertiseLevel
    requiredExpertiseLevel
    skillId
    skill {
      _id
    }
    isInValidation
  }
`);
